import jwt_decode from 'jwt-decode';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRefreshMutation } from '../../../app/Slices/SevenDayApiSlice';
import { homePathForRole } from '../../../shared/homePathForRole';

export default function HomeRedirect() {
    const [refresh] = useRefreshMutation();
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;

        const restoreSession = async () => {
            try {
                const refreshed = await refresh({}).unwrap();
                if (cancelled) return;

                const accessToken = refreshed?.accessToken;
                if (!accessToken) {
                    navigate('/login', { replace: true });
                    return;
                }

                const decode = jwt_decode<{ role?: string }>(accessToken);
                navigate(homePathForRole(decode.role), { replace: true });
            } catch {
                if (!cancelled) navigate('/login', { replace: true });
            }
        };

        restoreSession();

        return () => {
            cancelled = true;
        };
    }, [refresh, navigate]);

    return null;
}
